/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import ScheduleEnum from '../../schedule/schedule-enum';

/**
 * Komunikátor plánů přehrávání pro Ki-Wi Server.
 */
class CommunicatorSchedule {
  /**
   * Zpracuje plán přehrávání.
   * @param {string} [value] Plán ve formátu, který vrací server.
   * @returns {ScheduleEnum|null} Plán přehrávání ke vložení do datového skladu.
   */
  static parse(value) {
    switch (value) {
      case 'dynamic':
        return ScheduleEnum.DYNAMIC;
      case 'linear':
        return ScheduleEnum.STATIC;
      case 'shuffle':
        return ScheduleEnum.RANDOM;
      default:
        return null;
    }
  }
}

export default CommunicatorSchedule;
